import { getId } from "../utils";
import TurnGraph from "./turnGraph";
export var Reaction;
(function (Reaction) {
    Reaction[Reaction["HAPPY"] = 0] = "HAPPY";
    Reaction[Reaction["SAD"] = 1] = "SAD";
    Reaction[Reaction["ANGRY"] = 2] = "ANGRY";
    Reaction[Reaction["LAUGHING"] = 3] = "LAUGHING";
    Reaction[Reaction["AWESTRUCK"] = 4] = "AWESTRUCK";
})(Reaction || (Reaction = {}));
export default class ActiveHeadline {
    constructor(content, writtenOn) {
        this.id = getId();
        this.views = new TurnGraph();
        this.ctr = new TurnGraph();
        this.shares = new TurnGraph();
        this.revenue = new TurnGraph();
        this.demonetized = false;
        this.advertiseImpressions = 0;
        this.impressions = 0;
        this.reactions = {
            [Reaction.HAPPY]: 0,
            [Reaction.SAD]: 0,
            [Reaction.ANGRY]: 0,
            [Reaction.LAUGHING]: 0,
            [Reaction.AWESTRUCK]: 0,
        };
        this.content = content;
        this.writtenOn = writtenOn;
    }
    turn(turn) {
        this.views.turn(turn);
        const ctr = this.views.latest / this.impressions;
        this.ctr.setValue(ctr);
        this.ctr.turn(turn);
        this.shares.turn(turn);
        this.revenue.turn(turn);
    }
    addImpression(read, share, reaction) {
        this.impressions++;
        if (read) {
            this.views.add(1);
            if (!this.demonetized)
                this.revenue.add(0.01);
            if (share)
                this.shares.add(1);
            if (reaction)
                this.reactions[reaction]++;
        }
    }
    flagged(flag) {
        return this.content.flags.includes(flag);
    }
}
